import { CFPBox } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { AppSegmentedInput, AppSegmentedInputProps } from '@components';
import { UIHelper } from '@helpers';

type MultichannelInputProps = Omit<AppSegmentedInputProps, 'mask' | 'secureTextEntry'>;

export const MultichannelInput = ({ disabled, ...props }: MultichannelInputProps) => {
	// const { windowWidth } = useResponsive();
	// const [secureTextEntry, setSecureTextEntry] = useState(true);
	// const responsiveProps = getResponsiveProps(windowWidth);

	return (
		<CFPBox styles={{ alignSelf: 'start', alignItems: 'start', gap: UIHelper.rem(8) }}>
			<AppSegmentedInput {...props} mask="numeric" secureTextEntry disabled={disabled} />

			{/* TODO: CF SegmentedInput doesn't behave correctly when changing "secureTextEntry" in runtime, and using the mask="numeric" */}
			{/* <Button.Icon
				{...responsiveProps.buttonIcon}
				variant="tertiary"
				size="medium"
				disabled={disabled}
				content={secureTextEntry ? <Show /> : <Hidden />}
				onPress={() => setSecureTextEntry((prev) => !prev)}
			/> */}
		</CFPBox>
	);
};

// const getResponsiveProps = (
// 	windowWidth: number
// ): {
// 	segmentedInput: Partial<AppSegmentedInputProps>;
// 	buttonIcon: Partial<IconButtonProps>;
// } => {
// 	if (windowWidth > 500) {
// 		return {
// 			segmentedInput: {
// 				gap: 's5',
// 				size: 'xxxLarge',
// 			},
// 			buttonIcon: {
// 				sx: {
// 					marginTop: UIHelper.rem(14),
// 				},
// 			},
// 		};
// 	}

// 	return {
// 		segmentedInput: {
// 			gap: 's4',
// 			size: 'large',
// 		},
// 		buttonIcon: {
// 			sx: {
// 				marginTop: UIHelper.rem(14),
// 			},
// 		},
// 	};
// };
